module.exports = __webpack_public_path__ + "static/media/location-king-00992b.18a51ddb.svg";